import { useMemo } from 'react';
import { useIsReferralDisabledForState } from '~/hooks';
import { useIsParentOfficeSelector } from '~/hooks/useIsParentOfficeSelector';

export const useIsReferralProgramVisible = () => {
  const isParentOffice = useIsParentOfficeSelector();
  const isReferralScreenDisabledState = useIsReferralDisabledForState();

  const shouldShowReferralProgram = useMemo(() => {
    if (isReferralScreenDisabledState || isParentOffice) {
      return false;
    }

    return true;
  }, [isParentOffice, isReferralScreenDisabledState]);

  return shouldShowReferralProgram;
};
